<template lang="pug">
  y-dialog(v-model="showModal" fill-height fluid scrollable persistent transition="fade-transition" max-width="600px" :fullscreen="$vuetify.breakpoint.xsOnly")

    v-card(flat)
      v-card-title.px-5
        v-row(no-gutters align="center")
          v-col.shrink
            v-btn.ml-n3(text icon @click="showModal = !showModal" height)
              eva-icon(name="arrow-back-outline" :fill="$vuetify.theme.themes[$theme].primary500" width="24" height="24")
          v-col.ml-3
            p.mb-0.h6.primary500--text AWB address

      v-layout.my-6(v-if="isFetching")
        v-row.fill-height.ma-0(align='center' justify='center')
          v-progress-circular.ma-auto(:width="2" :size="50" color="primary" indeterminate)

      v-card-text.pa-0(v-else)
        v-form(ref="form")
          v-card.pa-4.mx-4(outlined flat)
            .s1 Enter your AWB address
            .c1.basic600--text This is the address that will be shown on your air waybill.
            div.awb.d-flex.mt-4
              y-checkbox.my-auto.mx-0.pa-0(v-model="same_for_awb_address" hide-details)
                template(v-slot:label)
                  .p1.my-auto Same as pickup address
            .address.mt-4
              div.label.basic600--text.text-uppercase {{$t('address_1.label')}}
              v-text-field.mt-2(v-model="address.address_1" :placeholder="$t('address_1.placeholder')" dense outlined height="40" background-color="basic200" :rules="rules.not_empty")
              div.label.basic600--text.text-uppercase {{$t('address_2.label')}}
              v-text-field.mt-2(v-model="address.address_2" :placeholder="$t('address_2.placeholder')" dense outlined height="40" background-color="basic200" :rules="rules.not_empty")
              div.label.basic600--text.text-uppercase {{$t('postcode.label')}}
              v-text-field.mt-2(v-model="address.postcode" :placeholder="$t('postcode.placeholder')" dense outlined height="40" background-color="basic200" :rules="rules.not_empty")
              div.label.basic600--text.text-uppercase {{$t('city.label')}}
              v-text-field.mt-2(v-model="address.city" :placeholder="$t('city.placeholder')" dense outlined height="40" background-color="basic200" :rules="rules.not_empty")
              div.label.basic600--text.text-uppercase {{$t('state.label')}}
              v-text-field.mt-2(v-model="address.state" :placeholder="$t('state.placeholder')" dense outlined height="40" background-color="basic200" :rules="rules.not_empty")
              div.label.basic600--text.text-uppercase {{$t('country.label')}}
              v-text-field.mt-2(v-model="address.country" :placeholder="$t('country.placeholder')" dense outlined height="40" background-color="basic200" :rules="rules.not_empty")

            .company-phone
              div.label.basic600--text.text-uppercase {{$t('phone.label')}}
              v-text-field.mt-2(v-model='address.phone' :placeholder="$t('phone.placeholder')" dense outlined height="40" type="tel" background-color="basic200" :rules="rules.not_empty")
            
        v-layout.ma-4
          v-spacer
          v-btn(color='textColorAccent' depressed :loading="isLoading" @click="clickSave")
            .button-AA-medium.basic100--text Save

</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'CourierAwbAddress',
  props: ['open', 'company', 'courier'],
  data: () => ({
    isFetching: false,
    same_for_awb_address: false,
    address: {
      address_1: '',
      address_2: '',
      postcode: '',
      city: '',
      state: '',
      country: '',
      phone: ''
    },
    isLoading: false,
    rules: {
      not_empty: [val => (val || '').length > 0 || 'This field is required']
    }
  }),
  computed: {
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    }
  },
  mounted () {
    this.fetchShippingCourier()
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    fetchShippingCourier() {
      this.isFetching = true
      this.$axios.get(`/shipping/yezzashipping/settings/${this.company.slug}/courier/address`)
        .then((response) => {
          this.address = response.data.pickup_address
        }).catch(() => {})
        .finally(() => { this.isFetching = false })
    },
    clickSave() {
      if (!this.$refs.form.validate()) {
        return
      }
      this.isLoading = true
      const params = { ...this.courier }
      params.awb_address = this.address
      this.axios.patch(`/shipping/yezzashipping/settings/${this.company.slug}/courier/${this.courier.id}`, params)
        .then(() => {
          this.showModal = false
          this.$emit('finished')
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
    }
  }
}
</script>

<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
</style>

<i18n>
{
  "en": {
    "update_company": "Update company details",
    "company_logo": "Company logo",
    "company_name": {
      "label": "Company Name",
      "placeholder": "Write your company name here"
    },
    "phone": {
      "label": "Phone number",
      "placeholder": "Enter phone number"
    },
    "registration_number": {
      "label": "Company Registration No",
      "placeholder": "Write your company registration number here"
    },
    "address_1": {
      "label": "Address Line 1",
      "placeholder": "e.g. K-3-01, Conezion, Persiaran IRC3"
    },
    "address_2": {
      "label": "Address Line 2",
      "placeholder": "e.g. IOI Resort City"
    },
    "postcode": {
      "label": "Postcode",
      "placeholder": "e.g. 62502"
    },
    "city": {
      "label": "City",
      "placeholder": "e.g. Putrajaya"
    },
    "state": {
      "label": "State",
      "placeholder": "e.g. Wilayah Persekutuan Putrajaya"
    },
    "country": {
      "label": "Country",
      "placeholder": "e.g. Malaysia"
    },
    "tax_rate": {
      "label": "Tax rate",
      "placeholder": "Default tax rate for price calculation"
    },
    "cancel": "Cancel",
    "update": "Update"
  },
  "id": {
    "update_company": "Perbaru detail perusahaan",
    "company_logo": "Logo perusahaan",
    "company_name": {
      "label": "Nama perusahaan",
      "placeholder": "Tulis nama perusahaan di sini"
    },
    "phone": {
      "label": "Nomor HP",
      "placeholder": "Tulis nomor HP"
    },
    "registration_number": {
      "label": "Nomor pendaftaran perusahaan",
      "placeholder": "Tulis Nomor pendaftaran perusahaan"
    },
    "address_1": {
      "label": "Nama Jalan, Gedung, No Rumah, RT/RW, Kelurahan",
      "placeholder": "e.g. Jalan Prof. Joko Sutono Sh No.999, RT.14/RW.6, Petogogan, "
    },
    "address_2": {
      "label": "Kecamatan",
      "placeholder": "Kec. Kby. Baru"
    },
    "postcode": {
      "label": "Kode Pos",
      "placeholder": "12160"
    },
    "city": {
      "label": "Kota",
      "placeholder": "Kota Jakarta Selatan"
    },
    "state": {
      "label": "Provinsi",
      "placeholder": "DKI Jakarta"
    },
    "country": {
      "label": "Negara",
      "placeholder": "e.g. Indonesia"
    },
    "tax_rate": {
      "label": "Persentase Pajak",
      "placeholder": "Tarif pajak default untuk perhitungan harga"
    },
    "cancel": "Batal",
    "update": "Perbarui"
  }
}
</i18n>
